import { buildHeadersFromDocumentParams } from '../../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { ConstructDelete } from '../../../types/ConstructDelete';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { FILTERS_BASE_PATH } from '../constants/filtersBasePath';

export const deleteFilter = async (
  constructDelete: ConstructDelete,
  uuid: string,
  params?: DocumentParams,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructDelete<NonPaginatedResponse<null>>(
    `${FILTERS_BASE_PATH}/${uuid}/destroy`,
    { headers: params ? buildHeadersFromDocumentParams(params) : undefined },
  );
